import React, { useContext, useEffect, useState } from 'react';
import {
  Box,
  TextField,
  Button,
  InputAdornment,
  useTheme,
} from '@mui/material';
import {
  FaUser,
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaTwitter,
} from 'react-icons/fa';
import { FcCopyright } from 'react-icons/fc';
import PropTypes from 'prop-types';
import toast from 'react-hot-toast';
import { AuthContext } from '../../../../../context/AuthContext';
import { GlobalContext } from '../../../../../context/GlobalContext';

const CopyrightAndSocialForm = ({ setShowFooterSettingModal }) => {
  const theme = useTheme();
  const { apiGlobal, userid } = useContext(AuthContext);
  const { setIsFooterUpdate } = useContext(GlobalContext);
  // console.log(userid);

  const [formData, setFormData] = useState({
    copyrightContent: '',
    facebook: '',
    instagram: '',
    linkedin: '',
    twitter: '',
  });

  // Handle input change
  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
  
    try {
      const formdata = new FormData();
      formdata.append('userId', userid);
      formdata.append('copyrightText', formData.copyrightContent);
      formdata.append('facebookLink', formData.facebook);
      formdata.append('instagramLink', formData.instagram);
      formdata.append('linkedInLink', formData.linkedin);
      formdata.append('twitterLink', formData.twitter);
  
      // Debug output
      // for (const [key, value] of formdata.entries()) {
      //   console.log(`${key}: ${value}`);
      // }
  
      const url = await fetch(`${apiGlobal}footer_setting_edit.php`, {
        method: 'POST',
        body: formdata, // ✅ use FormData object directly
      });
  
      const response = await url.json();
      console.log(response);
  
      if (response.status) {
        // alert('Footer settings updated successfully!');
        toast.success('Footer update SuccessFully');
        setIsFooterUpdate(prev => !prev);
        setShowFooterSettingModal(false);
      } else {
        alert(`Update failed: ${response.message}`);
      }
    } catch (error) {
      console.error('Submit Error:', error);
      alert('Something went wrong while submitting the form.');
    }
  };
  

  // Fetch existing data from backend
  const fetchFooterSetting = async () => {
    try {
      const res = await fetch(`${apiGlobal}get_footer_setting.php`);
      const response = await res.json();

      if (response?.status && response?.message === 'Success' && response?.data) {
        const { data } = response;
        setFormData({
          copyrightContent: data?.copyright_text || '',
          facebook: data?.facebook || '',
          instagram: data?.instagram || '',
          linkedin: data?.linkedin || '',
          twitter: data?.twitter || '',
        });
      } else {
        console.warn('No footer data found.');
      }
    } catch (error) {
      console.error('Error fetching footer data:', error);
    }
  };

  useEffect(() => {
    fetchFooterSetting();
  }, []);


  return (
    <Box
      sx={{
        width: { xs: '90%', sm: 450 },
        padding: 5,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 4,
        boxShadow: 10,
        backgroundColor: theme.palette.background.paper,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <form onSubmit={handleSubmit} style={{ width: '100%' }}>
        {/* Copyright Content */}
        <TextField
          fullWidth
          label="Copyright Content"
          name="copyrightContent"
          value={formData.copyrightContent}
          onChange={handleChange}
          margin="normal"
          variant="outlined"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                {/* <FaUser color={theme.palette.text.secondary} /> */}
                <FcCopyright color={theme.palette.text.secondary} />
              </InputAdornment>
            ),
          }}
        />

        {/* Facebook */}
        <TextField
          fullWidth
          label="Facebook Link"
          name="facebook"
          value={formData.facebook}
          onChange={handleChange}
          margin="normal"
          variant="outlined"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <FaFacebook color="#1877F2" />
              </InputAdornment>
            ),
          }}
        />

        {/* Instagram */}
        <TextField
          fullWidth
          label="Instagram Link"
          name="instagram"
          value={formData.instagram}
          onChange={handleChange}
          margin="normal"
          variant="outlined"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <FaInstagram color="#E4405F" />
              </InputAdornment>
            ),
          }}
        />

        {/* LinkedIn */}
        <TextField
          fullWidth
          label="LinkedIn Link"
          name="linkedin"
          value={formData.linkedin}
          onChange={handleChange}
          margin="normal"
          variant="outlined"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <FaLinkedin color="#0A66C2" />
              </InputAdornment>
            ),
          }}
        />

        {/* Twitter */}
        <TextField
          fullWidth
          label="Twitter Link"
          name="twitter"
          value={formData.twitter}
          onChange={handleChange}
          margin="normal"
          variant="outlined"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <FaTwitter color="#1DA1F2" />
              </InputAdornment>
            ),
          }}
        />

        {/* Submit Button */}
        <Button
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
          sx={{
            mt: 4,
            borderRadius: 3,
            py: 1.5,
            fontWeight: 'bold',
            fontSize: '1rem',
            letterSpacing: 1,
          }}
        >
          Save Changes
        </Button>
      </form>
    </Box>
  );
};

CopyrightAndSocialForm.propTypes = {
  setShowFooterSettingModal: PropTypes.func.isRequired,
};

export default CopyrightAndSocialForm;
